import { CustomText } from '@vfit/shared/atoms';
import { Title, Description, DetailsContainer, Content } from './modemDetailsV2.style';
import { IModemProps } from './modemDetailsV2.models';

const ModemDetailsV2 = ({ title, content }: IModemProps) => (
  <DetailsContainer>
    <Content>
      <Title>
        <CustomText text={title} />
      </Title>
      <Description>
        <CustomText text={content} />
      </Description>
    </Content>
  </DetailsContainer>
);

export default ModemDetailsV2;

